import Animated from 'react-native-reanimated'

export * from 'react-native-reanimated'
// eslint-disable-next-line import/no-default-export
export default Animated
